import { Ruler } from 'lucide-react'
import React, { FC } from 'react'
import styled from 'styled-components'

import { tooltipStyles } from './styles'

const MeasureButton = styled.div<{ $selected: boolean }>`
  ${tooltipStyles}
  cursor: pointer;
  background-color: ${({ $selected }) =>
    $selected ? 'rgba(0, 255, 136, 0.3)' : 'rgba(20, 20, 30, 0.8)'};
  padding: 8px 12px;
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  border: 1px solid
    ${({ $selected }) =>
      $selected ? 'rgba(0, 255, 136, 0.5)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 6px;
  position: relative;
  transition: all 0.15s ease;

  &:hover {
    background-color: ${({ $selected }) =>
      $selected ? 'rgba(0, 255, 136, 0.4)' : 'rgba(40, 40, 50, 0.9)'};
  }
`

const IconWrapper = styled.div<{ $active: boolean }>`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $active }) => ($active ? '#00ff88' : 'white')};
`

const ShortcutBadge = styled.div`
  position: absolute;
  bottom: 2px;
  right: 4px;
  font-size: 9px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
  font-weight: 600;
`

interface MeasurementToolHotbarProps {
  isMeasuring: boolean
  onToggle: () => void
}

/**
 * Hotbar button to toggle the measurement tool on/off
 */
export const MeasurementToolHotbar: FC<MeasurementToolHotbarProps> = ({
  isMeasuring,
  onToggle,
}) => {
  return (
    <MeasureButton
      $selected={isMeasuring}
      onClick={onToggle}
      data-tooltip={
        isMeasuring ? 'Exit measure mode (M)' : 'Measure distance (M)'
      }>
      <IconWrapper $active={isMeasuring}>
        <Ruler size={18} />
      </IconWrapper>
      <ShortcutBadge>M</ShortcutBadge>
    </MeasureButton>
  )
}
